import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { withSnackbar } from 'notistack';
import Button from 'components/Button';
import CloseIcon from '@material-ui/icons/Close';
import checkCircleGreen from 'assets/img/check_circle.svg';
import InfoIcon from '@material-ui/icons/Info';
import classes from './Snackbar.module.scss';

const defaultOptions = {
  autoHideDuration: 3000,
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'left',
  },
};

const Snackbar = ({ enqueueSnackbar, closeSnackbar, handleOnClose, ...props }) => {
  const { history, type, open, message, options, actionComponents, callback, ...others } = props;

  const handleClose = (key) => {
    if (key) closeSnackbar(key);
    else closeSnackbar();
  };

  const renderActionComponent = (snackbarKey) =>
    actionComponents.map((item, index) => {
      const { Component, componentProps, children, onClickAction } = item;

      return (
        Component && (
          <Component
            key={index}
            onClick={() => {
              handleClose(snackbarKey);
              onClickAction();
            }}
            {...componentProps}>
            {children}
          </Component>
        )
      );
    });

  const renderSnackbarContent = (snackbarKey) => {
    const contentClassName = clsx({
      [classes.success]: type === 'success',
      [classes.error]: type === 'error',
      [classes.warning]: type === 'warning',
      [classes.info]: type === 'info',
      [classes.green_success]: type === 'green_success',
    });

    return (
      <div key={snackbarKey} className={clsx(classes.wrapper, contentClassName)}>
        {type === 'success' && (
          <img src={checkCircleGreen} alt="checkCircleGreen" style={{ marginRight: 14 }} />
        )}
        {type === 'error' && (
          <InfoIcon
            style={{
              color: '#FF5555',
              marginRight: 14,
            }}
          />
        )}
        {message}
        {renderActionComponent(snackbarKey)}
        <Button
          type="icon"
          buttonProps={{
            onClick: () => {
              handleOnClose();
              handleClose();
            },
            className: classes.closeButton,
          }}>
          <CloseIcon />
        </Button>
      </div>
    );
  };

  const handleOpen = () => {
    // message is empty string by default to customize content
    enqueueSnackbar('', {
      variant: type,
      ...defaultOptions,
      ...options,
      ...others,
      open,
      content: (key) => renderSnackbarContent(key),
      onClose: () => {
        if (options.onClose) options.onClose();
        if (callback) callback();
      },
    });
  };

  useEffect(() => {
    if (open) handleOpen();

    setTimeout(() => {
      history.replace();
    }, [defaultOptions.autoHideDuration]);

    // eslint-disable-next-line
  }, [open]);

  return <></>;
};

Snackbar.defaultProps = {
  type: 'success',
  open: false,
  message: '',
  options: {},
  actionComponents: [],
  callback: null,
  handleOnClose: () => {},
};

Snackbar.propTypes = {
  enqueueSnackbar: PropTypes.func.isRequired,
  closeSnackbar: PropTypes.func.isRequired,
  type: PropTypes.string,
  open: PropTypes.bool,
  message: PropTypes.string,
  options: PropTypes.object,
  actionComponents: PropTypes.arrayOf(PropTypes.object),
  callback: PropTypes.func,
  handleOnClose: PropTypes.func,
};

export default withRouter(withSnackbar(Snackbar));
